module.exports = __webpack_public_path__ + "static/media/eyes.cd0d990a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/img/eyes.svg
// module id = 29
// module chunks = 0